/**
* this is the menu item component for the left and right menu
*
* Created by Tom on 28/5/18
*/

import React from 'react'
import PropTypes from 'prop-types'

// icon imports
import LinkIcon from '../../assets/svg/newlink.svg'
import ArrowIcon from '../../assets/svg/arrow.svg'

// style import
import './style.scss'
import cx from "classnames";


const MenuItem = ({svgIcon, isExternal, menuText, route, onClick, pathname}) => {

    const leftIconAltText = `Menu item left icon for ${menuText}`

    const dynClass = cx(
        'menu-item',
        {'menu-item--active': route === pathname}
    )

    return (
        <div
            className={dynClass}
            onClick={onClick}>

            {/* left icon or blank spaceholder */}
            {
                (svgIcon
                    ?
                    <img
                        src={svgIcon}
                        className="menu-item__left-icon"
                        alt={leftIconAltText} />
                    :
                    null
                )
            }

            {/* menu text */}
            <p className="menu-item__menu-text">{menuText}</p>

            {/* left icon - w/o container and link */}
            {
                (isExternal
                    ?
                    <div className="menu-item__right-icon-container">
                        <img
                            src={LinkIcon}
                            className="menu-item__right-icon-container__right-icon-external"
                            alt="Avatar icon" />
                    </div>
                    :
                    <img
                        src={ArrowIcon}
                        className="menu-item__right-icon"
                        alt="Arrow icon" />
                )
            }

        </div>
    )
}

// define the prop types
MenuItem.propTypes = {
    svgIcon: PropTypes.string,
    isExternal: PropTypes.bool,
    menuText: PropTypes.string,
    onClick: PropTypes.func,
    pathname: PropTypes.string,
}

export default MenuItem



// WEBPACK FOOTER //
// ./src/components/MenuItem/index.js